import { React } from "react";
import { Card } from "react-bootstrap";
import { ethers } from "ethers";
import "../../css/NFTCard.css";
import "../../css/global.css";

const NFTCard = ({ _nft }) => {

    const toBN = (text) => {
        const _bn = ethers.BigNumber.from(text);
        return _bn.toString()
    }
  
    const print = `
       id.tokenId:                              ${_nft.id.tokenId},
       description:                             ${_nft.description},
       contract.address:                        ${_nft.contract.address},
       timeLastUpdated:                         ${_nft.timeLastUpdated},          
       title:                                   ${_nft.title},
       
       tokenUri.gateway:                        ${_nft.tokenUri.gateway},
       tokenUri.gateway.animation_url:          ${_nft.tokenUri.gateway.animation_url},
       tokenUri.gateway.name:                   ${_nft.tokenUri.gateway.name},
       tokenUri.gateway.image:                  ${_nft.tokenUri.gateway.image},
       tokenUri.raw:                            ${_nft.tokenUri.raw},
 
       media[0].bytes:                          ${_nft.media[0].bytes},
       media[0].format:                         ${_nft.media[0].format},
       media[0].gateway:                        ${_nft.media[0].gateway},
       media[0].raw:                            ${_nft.media[0].raw},
       media[0].thumbnail:                      ${_nft.media[0].thumbnail},

       contractMetadata.name:                   ${_nft.contractMetadata.name},
       contractMetadata.symbol:                 ${_nft.contractMetadata.symbol},
       contractMetadata.totalSupply:            ${_nft.contractMetadata.totalSupply},
       contractMetadata.tokenType:              ${_nft.contractMetadata.tokenType},
       
       metadata.animation_url:                  ${_nft.metadata.animation_url},
       metadata.description:                    ${_nft.metadata.description},
       metadata.external_url:                   ${_nft.metadata.external_url},
       metadata.image:                          ${_nft.metadata.image},
       metadata.name:                           ${_nft.metadata.name},
       metadata.attributes:                     ${_nft.metadata.attributes},


 
       contractMetadata.openSea.collectionName: ${_nft.contractMetadata.openSea.collectionName},
       contractMetadata.openSea.description:    ${_nft.contractMetadata.openSea.description},
       contractMetadata.openSea.discordUrl:     ${_nft.contractMetadata.openSea.discordUrl},
       contractMetadata.openSea.externalUrl:    ${_nft.contractMetadata.openSea.externalUrl},
       contractMetadata.openSea.floorPrice:     ${_nft.contractMetadata.openSea.floorPrice},
       contractMetadata.openSea.imageUrl:       ${_nft.contractMetadata.openSea.imageUrl},
       contractMetadata.openSea.lastIngestedAt: ${_nft.contractMetadata.openSea.lastIngestedAt},
       contractMetadata.openSea.safelistRequestStatus: ${_nft.contractMetadata.openSea.safelistRequestStatus},
       contractMetadata.openSea.twitterUsername: ${_nft.contractMetadata.openSea.twitterUsername},
    `;
 

    console.log(print);

    return (
        <>
        
            <Card className="nft-card nft-card--music rounded g-4" style={{width: '35rem'}}>
                <div className="nft-card--header">
                    <div className="nft-user">
                        <img alt=" " src={_nft.contractMetadata.openSea.imageUrl}/>
                        {_nft.contractMetadata.openSea.collectionName}
                    </div>
                </div>
                <div className="nft-card--content">
                    <div className='wave'></div>
                    <div className='wave'></div>
                    <div className='wave'></div>

                    <div className="nft-action">
                        <span><i className="far fa-heart"></i>{_nft.contractMetadata.tokenType} </span>
                    </div>
                    <img alt="NFT" src={!_nft.metadata.image ? _nft.media[0].raw : _nft.metadata.image}/>
                    <div className="nft-qrcode">
                    {toBN(_nft.id.tokenId)}
                        <span> / {_nft.contractMetadata.totalSupply}</span>
                        <i className="fas fa-qrcode"></i>
                    </div>
                </div>
                <div className="nft-card--footer">
                    <div className="nft-price m-3">
                        <span style={{textAlign: "right", fontStyle: "italic Bold", fontSize: "20px"}}>{!_nft.metadata.name ? _nft.contractMetadata.openSea.collectionName : _nft.metadata.name}</span>
                        <span><p style={{color: "#0d6efd", textAlign: "right", width: "-75%", overflow: "clip", textOverflow: "ellipsis", fontStyle: "italic", fontSize: "65%", fontWeight: "bolder"}}>{_nft.contract.address}</p></span>
                        <i className="fab fa-ethereum"></i> {_nft.contractMetadata.openSea.floorPrice} ETH
                    </div>
                    <div className="nft-time">
                        <span style={{margin: "3.5", fontStyle: "italic"}}><i className="fab fa-text" ></i> {!_nft.metadata.description ? _nft.contractMetadata.openSea.description : _nft.metadata.description}</span>
                    </div>
                </div>
            </Card>


            {/* <Col>
                <Card className="rounded g-4" border={"light"} style={{ width: '18rem' }}>
                <Card.Img variant="top" src={nft.media[0].gateway} />
                <Card.Header as={"h6"} style={{ fontStyle: "italic" }}>{nft.title}</Card.Header>
                <Card.Body>
                <Card.Title>{toBN(nft.id.tokenId)}</Card.Title>
                <Card.Subtitle className="mb-2 text-muted">{nft.contract.address}</Card.Subtitle>
                <Card.Text style={{ fontStyle: "italic", fontSize: "xs" }}>
                {nft.description}
                </Card.Text>
                </Card.Body>
                </Card>
                </Col>
            */}

            </>
    )
}

export { NFTCard }